import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import Grid from '@material-ui/core/Grid/Grid';
import MultipleInstallments from 'components/Cart/Price/MultipleInstallments';
import { IProductData } from 'interfaces/IProductData';
import UserInfos from 'components/Cart/Templates/Mobile/OneClickBuy/UserInfos';
import Installments from 'components/Cart/MainForm/Payment/PaymentForm/CreditCardForm/Installments';
import CreditCard from 'components/Cart/Templates/Mobile/OneClickBuy/CreditCard';
import { paymentService } from 'services/PaymentService';
import { cartService } from 'services/CartService';
import Translate from 'components/Translate';
import { Subscription } from 'components/Cart/Price/Subscription';
import AcceptTerms from 'components/AcceptTerms';
import { enPaymentType } from 'enums/enPaymentType';
import WithoutInstallment from 'components/Cart/Price/WithoutInstallment';
import PaymentButton from 'components/Cart/PaymentButton';
import { FieldValidation } from 'components/Field';
import { TicketTimer } from 'components/Cart/TicketTimer';
import Paper from '@material-ui/core/Paper/Paper';
import { enProductType } from 'enums/enProductType';
import QuantityForm from 'components/Cart/Physical/QuantityForm';
import { IS_ECOMMERCE } from 'settings';
import OrderBump from '../../../../OrderBump/index';
import OpenValue from 'components/Cart/OpenValue';
import { nl2br } from 'shared/functions';
import { ticketService } from 'services/TicketService';
import Summary from '../../../../Summary/index';

interface IProps {
  onPay?: any;
  cart?: IProductData;
  disableButton?: boolean;
}

interface IState extends IStateBase {
  showTimer: boolean;
}

export class ContentOneClickBuy extends BaseComponent<IState, IProps> {
  constructor(props: any) {
    super(props);
    this.state = { showTimer: false };
  }

  componentDidMount() {
    ticketService
      .show()
      .bindComponent(this)
      .subscribe(showTimer => {
        this.setState({ showTimer });
      });
  }

  editInfos = () => {
    paymentService.setPaymentData(0, { paymentMethod: null });

    cartService.enableAskAddress().subscribe();
    cartService.disableOneClickBuy().subscribe();
  };

  finish = async () => {
    if (await this.isFormValid()) {
      this.props.onPay();
    }
  };

  render() {
    const { cart } = this.props;
    const showTimer = this.state.showTimer;

    return (
      <div>
        <FieldValidation.Provider value={this.registerFields}>
          {showTimer && enProductType.TICKET === cart.config.productType ? (
            <Paper className="ticketTimer">
              <TicketTimer />
            </Paper>
          ) : null}
          <Grid className="chk-oneClickBuy__product" container direction="row" justify="space-between" alignItems="center">
            <Grid item xs={6} className="chk-oneClickBuy__title">
              <h1 className="product-name">{cart.content.title}</h1>
            </Grid>
            <Grid item xs={6} className="chk-oneClickBuy__productPrice">
              {[enPaymentType.NORMAL, enPaymentType.ECOMMERCE].includes(cart.config.paymentType) ? (
                cart.installments.length > 1 ? (
                  <MultipleInstallments cart={cart} />
                ) : (
                  <WithoutInstallment cart={cart} />
                )
              ) : null}

              {cart.config.paymentType === enPaymentType.SUBSCRIPTION ? <Subscription cart={cart} /> : null}
            </Grid>
            <Grid item xs={12}>
              <OpenValue />
            </Grid>
            {enProductType.TICKET === cart.config.productType && !IS_ECOMMERCE ? (
              <div className="quantityContent">
                <label>Qtde</label>
                <QuantityForm hideLabel />
              </div>
            ) : null}
            {enProductType.TICKET === cart.config.productType && IS_ECOMMERCE ? (
              <div className="quantityContent">{nl2br(cart.products[0].description)}</div>
            ) : null}
          </Grid>

          <Grid item xs={12} className="chk-oneClickBuy__content">
            <div className="chk-oneClickBuy__form">
              <div className="chk-oneClickBuy__card">
                <CreditCard creditCard={cart.user.creditCard} askCVV={cart.config.askCVV} />
              </div>

              <Installments index={0} />

              <Grid item xs={12}>
                <OrderBump />

                <Summary />

                <PaymentButton finish={this.finish} disabledButton={this.props.disableButton} messageButton="Compra Segura" singleStep={true} />

                {cart.config.paymentType == enPaymentType.SUBSCRIPTION ? <AcceptTerms /> : null}
              </Grid>

              <div className="chk-oneClickBuy__details" id="ocb-details">
                <h6>
                  <Translate term="Detalhes do Pedido" />
                </h6>
                <UserInfos infos={[cart.user.name, cart.user.email]} />
              </div>

              <div className="chk-oneClickBuy__editInfosButton theme-label">
                <a id="chk-editinfo-button" href="#" onClick={this.editInfos}>
                  <Translate term="Editar dados" />
                </a>
              </div>
            </div>
          </Grid>
        </FieldValidation.Provider>
      </div>
    );
  }
}
